import { memo as Memo, useMemo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

//* HOC's
import withLanguageContext from '@context/consumerHOC/LanguageConsumer';

//* Helpers
import breakString from '@helpers/breakString';

//* Components
import Text from '@/components/global/Text';
import MinTitle from '@components/global/MinTitle';

//* Styles
import WorkProcessStyle from './style';

const WorkProcess = Memo(({ data, title, active, translate }) => {
	//! Refs
	const topRef = useRef();

	//! Animation
	const tl = useMemo(() => gsap.timeline({ delay: 0.4 }), []);

	useEffect(() => {
		let arr = [];

		data.map((i, k) => {
			return arr.push(topRef.current.childNodes[1].childNodes[k], topRef.current.childNodes[1].childNodes[k].childNodes[0], topRef.current.childNodes[1].childNodes[k].childNodes[1].childNodes[0], topRef.current.childNodes[1].childNodes[k].childNodes[1].childNodes[1]);
		});

		if (active) {
			tl.staggerTo(
				[arr],
				0,
				{
					opacity: 1,
				},
				0.1
			);
		} else {
			tl.staggerTo(
				[arr],
				0,
				{
					opacity: 0,
				},
				0
			);
		}
	}, [active]);

	return (
		<WorkProcessStyle ref={topRef}>
			<MinTitle
				active={active}
				title={breakString(title)}
			/>

			{data?.length > 0 ? (
				<div className={'workProcessItemsWrap'}>
					{data.map((item, ind) => {
						return (
							<div
								key={ind}
								className={'workProcessItems'}>
								<div className={'iconCont'}>
									<Text className={`p-m font-anonymous font-regular step`}>
										{'0' + (ind + 1)} {translate('step')}
									</Text>
								</div>

								<div className={'infoCont'}>
									<div className={'titleWrap'}>
										<Text
											tag={'h4'}
											className={`h6 font-poppins font-regular title`}>
											{item.title}
										</Text>
									</div>

									<Text className={`p-m font-poppins font-light description`}>{item.description}</Text>
								</div>
							</div>
						);
					})}
				</div>
			) : null}
		</WorkProcessStyle>
	);
});

export default withLanguageContext(WorkProcess, ['translate']);
